import IMAGES from "@/public/assets/img";
import { WEB_URL } from "@/config/endpoints";

export default {
  SeoContent:{
    title: "Global Buyer's",
    url: WEB_URL+'/en-us/global-buyer',
    description:'Global Buyers Dashboard | Real-Time Data Insights',
    keyword: 'supply chain finance, supply chain in finance,supply chain finance company', 
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
  },
  HomeNewData: {
    mainHeading: `<span class="font-normal text-headingbold sm:text-heading3 leading-[54px]">Fund your </span> <span class="font-medium text-headingbold sm:text-heading3 leading-[54px]">Suppliers</span>`,
    text: "<span style='color:#00AFFF;'>without delays </span>with Credlix and <br/> <span style='color:#00AFFF;'> Strengthen Business </span> Relation.",
  },
  Dashboard: {
    mainHeading: "Gain Control with a Smart, Real-Time Buyer Dashboard​",
    imagePath: IMAGES?.globalBuyer?.buyersDashboard,
  },
  sliderMainHeading: {
    heading: "Unlock Flexible Financing Solutions as a <br/> Buyer for better Supplier Relationship",
    subHeading: "Ensure supply chain stability with fast, collateral-free financing for import & export needs."
  },
  posts: [
    {
      id: 1,
      title: "Boost Cash Flow and Strengthen Business",
    },
    {
      id: 2,
      title: "Build Strong, Long-Lasting Supplier Partnerships",
    },
    {
      id: 3,
      title: "Supply Chain Stability",
    },
    {
      id: 4,
      title: "Operational Efficiency",
    },
  ],

  SliderBuyerHeading: {
    Heading:
      "<span style='color:black;'>Unlock</span> Flexible Financing Solutions as a <br/> Buyer for better Supplier Relationship",
    subHeading:
      "Ensure supply chain stability with fast, collateral-free financing for import & export needs.",
  },
  sliderBuyer: [
    {
      id: 1,
      image: IMAGES.globalBuyer.benefitsBuyers,
      // BenefitsHeading: "Boost Cash Flow and Strengthen Business",
      BenefitsPayments: "Fast Payment : ",
      BenefitsPaymentsDesc:
        "Suppliers get instant payment post-delivery, enabling quick reinvestment and leveraging arbitrage (taking advantage of price differences across markets)​.",
      BenefitsFinancial: "Lower Financial Strain :",
      BenefitsFinancialDesc:
        "Invoice discounting improves liquidity, helping suppliers optimize market pricing.",
    },
    {
      id: 2,
      image: IMAGES.globalBuyer.relationshipBuyers,
      // BenefitsHeading: "Build Strong, Long-Lasting Supplier Partnerships",
      BenefitsPayments: "Trust and Reliability : ",
      BenefitsPaymentsDesc:
        "Buyers using invoice discouting show commitement to suppliers financial well-being, fostering stronger ties",
      BenefitsFinancial: "Better Negotiation Power: ",
      BenefitsFinancialDesc:
        "Suppliers with strong cash flow can offer discounts, negotiate better terms, and maintain stable pricing",
    },
    {
      id: 3,
      image: IMAGES.globalBuyer.stabilityBuyers,
      // BenefitsHeading: "Supply Chain Stability",
      BenefitsPayments: "Continuity of Supply : ",
      BenefitsPaymentsDesc:
        "Stable suppiler cash flow prevents disruptions, ensuring timely deliveries",
      BenefitsFinancial: "Reduced Risk of Suppiler Bankruptcy :",
      BenefitsFinancialDesc:
        "Instant payments reduce insolvency risks, protecting your suppily chain",
    },
    {
      id: 4,
      image: IMAGES.globalBuyer.efficiencyBuyers,
      // BenefitsHeading: "Operational Efficiency",
      BenefitsPayments: "Streamlined operations : ",
      BenefitsPaymentsDesc:
        "Factoring manages payments, letting suppliers focus on core tasks",
      BenefitsFinancial: "Lower Costs for Suppliers :",
      BenefitsFinancialDesc:
        "Factoring costs less than loans improving pricing and terms for buyers",
    },
  ],

  BenefitsHeading: {
    heading: "Benefits for Both Buyers and Suppliers!",
  },
  sections: [
    {
      title: "Benefits for Buyer",
      backgroundColor: "bg-yellow-100",
      items: [
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "Support your Suppliers",
          description: "Strengthen relationships by securing required capital.",
        },
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "Maintain Control",
          description: "Continue to pay on your terms.",
        },
      ],
    },
  ],
  sections2: [
    {
      title: "Benefits for Supplier",
      backgroundColor: "bg-teal-100",
      items: [
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "Flexible Terms",
          description: "Match payments with business needs.",
        },
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "No More Chasing Payments",
          description: "Let Credlix manage the collection process.",
        },
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "Immediate Payment",
          description: "Access cash as soon as you issue an invoice.",
        },
      ],
    },
  ],

  solutionsSec: {
    heading: "Transform Your Cash Flow with Credlix",
    solutions: [
      {
        heading: "Export Factoring",
        paragraph:
          "Access non-recourse factoring for up to 90% of invoice value in 90+ countries, for up to 120 days.",
        src: IMAGES.globalBuyer.exportBuyer,
        href: "/export-factoring",
        learnmoreCta : 'Learn More',
      },
      {
        heading: "Supply Chain Financing",
        paragraph: "Strengthen supplier relationships with timely financing.",
        src: IMAGES.globalBuyer.financeBuyer,
        href: "/export-factoring/purchase-order-financing",
        learnmoreCta : 'Learn More',
      },
      {
        heading: "Collateral-Free Payments",
        paragraph: "Get funded up to $5M instantly, without collateral.",
        src: IMAGES.globalBuyer.paymentBuyer,
        href: "/export-factoring",
        learnmoreCta : 'Learn More',
      },
    ],
  },

  steps: [
    {
      number: "01",
      title: "Login Credentials",
      details: ["Email", "Password"],
    },
    {
      number: "02",
      title: "Select Supplier from Drop down list",
      details: ["Supplier list has to be uploaded on the portal."],
    },
    {
      number: "03",
      title: "Details Entry",
      details: [
        "Invoice No.",
        "Invoice Value",
        "Invoice Amount",
        "Funding Amount",
      ],
    },
    {
      number: "04",
      title: "Payment Terms",
      details: ["1. Payment term as per Invoice", "2. Requested Payment term"],
    },
    {
      number: "05",
      title: "Invoice Upload",
      details: ["Digital copy of Invoice need to be uploaded"],
    },
    {
      number: "06",
      title: "Submit for Payment",
      details: [],
    },
  ],

  BuyerPayment: {
    imagePath: IMAGES?.globalBuyer?.arrowBuyersDesktop,
    imagePathMob: IMAGES?.globalBuyer?.arrowBuyersMobile,
  },

  Faq_heading: "FAQs",
  Home_Faq: [
    {
      id: 0,
     question: "What is invoice discounting or factoring?​",
     answers: "Suppliers get early payment on invoices through a factoring company. The company pays a percentage upfront, and buyers repay them on the due date.​",
    },
    {
      id: 1,
     question: "How does invoice discounting benefit me as a buyer?​",
     answers: "It helps suppliers with cash flow, strengthening relationships, reducing supply chain risks, and potentially improving terms and pricing.​",
    },
    {
      id: 2,
     question: "What is the cost of invoice discounting for buyers?​",
     answers: "There’s a fee charged by the factoring company, usually a small percentage of the invoice. Costs vary by company and terms.​",
    },
    {
      id: 3,
     question: "How does invoice discounting affect my cash flow?​",
     answers: "It doesn’t impact your cash flow directly. You pay the factoring company on the due date, which helps stabilize your supply chain.​",
    },
    {
      id: 4,
     question: "Will invoice discounting affect my relationship with suppliers?​",
     answers: "It can improve relationships by supporting supplier stability, leading to better partnerships and negotiation terms.​",
    },
    {
      id: 5,
     question: "How do I get started with invoice discounting for my suppliers?​",
     answers: "Contact a factoring company to discuss options and set up an agreement.​",
    },
    {
      id: 6,
     question: "Are there any risks involved in invoice discounting?​",
     answers: "The main risk is potential impacts on customer relations due to payment collection management. Many companies offer discreet services to handle this.​",
    },
    {
      id: 7,
     question: "Can I choose which invoices to discount?​",
     answers: "Yes, you can select which invoices to discount based on your needs and agreements.​",
    },
    {
      id: 8,
     question: "How will invoice discounting impact my financial statements?​",
     answers: "It appears as a liability or expense in your financial statements, but doesn’t affect revenue directly.​",
    },
    {
      id: 9,
     question: "Can invoice discounting be used for all suppliers?",
     answers: "Yes, as long as suppliers agree and the factoring company accepts the invoices.​",
    },
  ],

  country_Name: [
    {
      id: 1,
      name: "Andorra",
      code: "376",
    },
    {
      id: 2,
      name: "Aruba",
      code: "297",
    },
    {
      id: 3,
      name: "Australia",
      code: "61",
    },
    {
      id: 4,
      name: "Austria",
      code: "43",
    },
    {
      id: 5,
      name: "Belgium",
      code: "32",
    },
    {
      id: 6,
      name: "Botswana",
      code: "267",
    },
    {
      id: 7,
      name: "Brazil",
      code: "55",
    },
    {
      id: 8,
      name: "Bulgaria",
      code: "359",
    },
    {
      id: 9,
      name: "Canada",
      code: "1",
    },
    {
      id: 10,
      name: "Chile",
      code: "56",
    },
    {
      id: 11,
      name: "China",
      code: "86",
    },
    {
      id: 12,
      name: "Croatia",
      code: "385",
    },
    {
      id: 13,
      name: "Cyprus",
      code: "357",
    },
    {
      id: 14,
      name: "Czech Republic",
      code: "420",
    },
    {
      id: 15,
      name: "Denmark",
      code: "45",
    },
    {
      id: 16,
      name: "Estonia",
      code: "372",
    },
    {
      id: 17,
      name: "Finland",
      code: "358",
    },
    {
      id: 18,
      name: "France",
      code: "33",
    },
    {
      id: 19,
      name: "Germany",
      code: "49",
    },
    {
      id: 20,
      name: "Greece",
      code: "30",
    },
    {
      id: 21,
      name: "Hungary",
      code: "36",
    },
    {
      id: 22,
      name: "Iceland",
      code: "354",
    },
    {
      id: 23,
      name: "India",
      code: "91",
    },
    {
      id: 24,
      name: "Indonesia",
      code: "62",
    },
    {
      id: 25,
      name: "Ireland",
      code: "353",
    },
    {
      id: 26,
      name: "Israel",
      code: "972",
    },
    {
      id: 27,
      name: "Italy",
      code: "39",
    },
    {
      id: 28,
      name: "Japan",
      code: "81",
    },
    {
      id: 29,
      name: "Kazakhstan",
      code: "7",
    },
    {
      id: 30,
      name: "Kuwait",
      code: "965",
    },
    {
      id: 31,
      name: "Latvia",
      code: "371",
    },
    {
      id: 32,
      name: "Lithuania",
      code: "370",
    },
    {
      id: 33,
      name: "Luxembourg",
      code: "352",
    },
    {
      id: 34,
      name: "Malaysia",
      code: "60",
    },
    {
      id: 35,
      name: "Malta",
      code: "356",
    },
    {
      id: 36,
      name: "Mauritius",
      code: "230",
    },
    {
      id: 37,
      name: "Mexico",
      code: "52",
    },
    {
      id: 38,
      name: "Montserrat",
      code: "1664",
    },
    {
      id: 39,
      name: "Netherlands",
      code: "31",
    },
    {
      id: 40,
      name: "New Zealand",
      code: "64",
    },
    {
      id: 41,
      name: "Norway",
      code: "47",
    },
    {
      id: 42,
      name: "Panama",
      code: "507",
    },
    {
      id: 43,
      name: "Peru",
      code: "51",
    },
    {
      id: 44,
      name: "Philippines",
      code: "63",
    },
    {
      id: 45,
      name: "Poland",
      code: "48",
    },
    {
      id: 46,
      name: "Portugal",
      code: "351",
    },
    {
      id: 47,
      name: "Qatar",
      code: "974",
    },
    {
      id: 48,
      name: "Romania",
      code: "40",
    },
    {
      id: 49,
      name: "Saint Helena",
      code: "290",
    },
    {
      id: 50,
      name: "Saudi Arabia",
      code: "966",
    },
    {
      id: 51,
      name: "Serbia",
      code: "381",
    },
    {
      id: 52,
      name: "Singapore",
      code: "65",
    },
    {
      id: 53,
      name: "Slovakia",
      code: "421",
    },
    {
      id: 54,
      name: "Slovenia",
      code: "386",
    },
    {
      id: 55,
      name: "South Korea",
      code: "82",
    },
    {
      id: 56,
      name: "Spain",
      code: "34",
    },
    {
      id: 57,
      name: "Sweden",
      code: "46",
    },
    {
      id: 58,
      name: "Switzerland",
      code: "41",
    },
    {
      id: 59,
      name: "Taiwan",
      code: "886",
    },
    {
      id: 60,
      name: "Thailand",
      code: "66",
    },
    {
      id: 61,
      name: "Trinidad and Tobago",
      code: "1868",
    },
    {
      id: 62,
      name: "Turks and Caicos Islands",
      code: "1649",
    },
    {
      id: 63,
      name: "United Arab Emirates",
      code: "971",
    },
    {
      id: 64,
      name: "United Kingdom",
      code: "44",
    },
    {
      id: 65,
      name: "United States",
      code: "1",
    },
    {
      id: 66,
      name: "Uruguay",
      code: "598",
    },
  ],

  FormData: {
    Heading:  "<span style='font-weight:400;'>Finance </span> &nbspYour Suppliers",
    Company: "Company Name*",
    Email: "Email*",
    CountryName:'Country*',
    Country: "Country*",
    Mobile: "Mobile number*",
    SelectFunding: "Select Funding Requirement*",
    Submitbtn: "Secure Funding Now",
    ThankYou: "Successful Submission: Thank you for your interest.",
    requiredMessage: "This field is required.",
    emailMessage: "Email is not valid",
    phoneMessage: "Phone number is not valid",
  },
};
